import {getLabelByField} from "../../utils/fields/heatmaps.js";

const columns = [
	{
		id: 'Name',
		name: getLabelByField('Name'),
		sortable: true,
		selector: row => row.Name,
		cell: row => row.Name,
		width: '400px'
	}, {
		id: 'Contact',
		name: 'Contact',
		sortable: true,
		selector: row => row.Contact__r.Name,
		cell: row => row.Contact__r.Name,
		width: '200px'
	}, {
		id: 'Contact_Classification_1__c',
		name: 'Contact Classification',
		sortable: true,
		selector: row => row.Contact_Classification_1__c,
		cell: row => row.Contact_Classification_1__c,
		width: '200px'
	}, {
		id: 'AccountName',
		name: 'Account Name',
		sortable: true,
		selector: row => row.Related_Account__r.Name,
		cell: row => row.Related_Account__r.Name,
		width: '200px'
	}, {
		id: 'Account_Name__c',
		name: 'Account Name (Contact)',
		sortable: true,
		selector: row => row.Account_Name__c,
		cell: row => row.Account_Name__c,
		width: '200px'
	}, {
		id: 'Request_Reason__c',
		name: 'Request Reason',
		sortable: true,
		selector: row => row.Request_Reason__c,
		cell: row => row.Request_Reason__c,
		width: '150px'
	}, {
		id: 'Engagement_Status__c',
		name: 'Engagement Status',
		sortable: true,
		selector: row => row.Engagement_Status__c,
		cell: row => row.Engagement_Status__c,
		width: '150px'
	}, {
		id: 'Region__c',
		name: 'Region',
		sortable: true,
		selector: row => row.Region__c,
		cell: row => row.Region__c,
		width: '150px'
	}, {
		id: 'Role_Category__c',
		name: 'Role Category',
		sortable: true,
		selector: row => row.Role_Category__c,
		cell: row => row.Role_Category__c,
		width: '150px'
	}, {
		id: 'Target_Date__c',
		name: 'Target Date',
		sortable: true,
		selector: row => row.Target_Date__c,
		cell: row => row.Target_Date__c,
		width: '150px'
	}, {
		id: 'Touch_Base_Date__c',
		name: 'Touch Base Date',
		sortable: true,
		selector: row => row.Touch_Base_Date__c,
		cell: row => row.Touch_Base_Date__c,
		width: '150px'
	}
];

export default columns;